import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "basket",
  "use": "basket-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"basket\">\n<path d=\"M18.3057 6H5.69425C4.71658 6 3.8822 6.70683 3.72147 7.6712L1.38813 21.6712C1.18496 22.8903 2.12504 24 3.36092 24H20.6391C21.875 24 22.815 22.8903 22.6119 21.6712L20.2785 7.6712C20.1178 6.70683 19.2834 6 18.3057 6Z\" stroke-width=\"2\" />\n<path d=\"M8 11V5.25C8 2.90279 9.90279 1 12.25 1V1C14.5972 1 16.5 2.90279 16.5 5.25V11\" fill=\"none\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol